module.exports = __webpack_public_path__ + "S_right_click.40274604.png";